import { __module as length } from '../../../../../_virtual/length.js';

var hasRequiredLength;

function requireLength () {
	if (hasRequiredLength) return length.exports;
	hasRequiredLength = 1;
	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = length;
		/**
		 * Calculate the absolute difference between two numbers
		 * @ignore
		 * @param {number} numA
		 * @param {number} numB
		 * @return {number}
		 */
		function length(numA, numB) {
		  return Math.abs(numA - numB);
		}
		module.exports = exports["default"];
		
	} (length, length.exports));
	return length.exports;
}

export { requireLength as __require };
